import { ContextMenu, Props as ContextMenuProps } from '~/components/ContextMenu/ContextMenu';
import { HeadingTag, Heading as UiHeading } from '../Heading/Heading';
import { MoreHorizontalIcon } from '../Icon/MoreHorizontalIcon';
import { Container, ContainerWidth } from '../Container/Container';
import styles from './PageLayout.module.css';
import { HasStyle } from '~/types/HasStyle';
import { PropsWithChildren } from 'react';
import { Outlet } from 'react-router';
import { Button } from '../Button/Button';

type Props = PropsWithChildren & {
  width?: ContainerWidth;
  title?: string;
};

// eslint-disable-next-line react-refresh/only-export-components
function PageLayoutRoot(props: Props) {
  const { title, children, width } = props;

  return (
    <div className={styles.background}>
      <div className={styles.headingWrapper}>
        {title && (
          <UiHeading as="h1" className={styles.heading}>
            {title}
          </UiHeading>
        )}
      </div>
      <div className={styles.containerWrapper}>
        <Container className={styles.container} width={width}>
          <div className={styles.inner}>{children ?? <Outlet />}</div>
        </Container>
      </div>
    </div>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
function Context(props: Omit<ContextMenuProps, 'trigger'>) {
  return (
    <ContextMenu
      trigger={
        <Button variant="secondary" type="button" className={styles.contextButton} square>
          <MoreHorizontalIcon />
        </Button>
      }
      {...props}
    />
  );
}

// eslint-disable-next-line react-refresh/only-export-components
function Header({ children }: PropsWithChildren) {
  return <div className={styles.header}>{children}</div>;
}

// eslint-disable-next-line react-refresh/only-export-components
function Heading({ text, subText }: { text: string; subText?: string }) {
  return (
    <div>
      <UiHeading as="h2">{text}</UiHeading>
      {subText && (
        <UiHeading as="h3" style={{ color: 'var(--color-text-lighter)' }}>
          {subText}
        </UiHeading>
      )}
    </div>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
function SubHeading({ children, style, as = 'h3' }: PropsWithChildren & HasStyle & { as?: HeadingTag }) {
  return (
    <UiHeading style={{ borderBottom: '1px solid var(--color-fg-secondary)', paddingBottom: '12px', ...style }} as={as}>
      {children}
    </UiHeading>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
function Section({ children, style }: PropsWithChildren & HasStyle) {
  return (
    <section className={styles.section} style={style}>
      {children}
    </section>
  );
}

export const PageLayout = Object.assign(PageLayoutRoot, {
  SubHeading,
  Heading,
  Context,
  Section,
  Header,
});
